const footer = () => {
  /*
   * SELECTORS
   */
  let footerTabs = document.querySelectorAll('.label.with-toggle')

  /*
   * EVENTS
   */

  const toggleFooterTabs = () => {
    footerTabs.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.currentTarget.classList.toggle('open')
      })
    })
  }

  /*
   * ACTIONS
   */
  if (window.matchMedia('(max-width: 960px)').matches) {
    toggleFooterTabs();
  }
  /*
   * EXTRA EXPORTS
   */
};
export default footer;



// WEBPACK FOOTER //
// ./scripts/components/footer.js